export * from "./input-select.component";
